import { observable } from 'mobx'

export type ModalsType =
  | 'create-service-request'
  | 'common-service-drawer'
  | 'assign-dealer-submit-dialog'
  | 'modal-confirmation-submit-dialog'
  | 'installation-request'
  | 'request-table-setting'
  | 'dealer-assigned-drawer'
  | 'create-service-request'
  | 'assign-dealer-submit-dialog'
  | 'common-service-drawer'
  | 'on-site-service-drawer'
  | 'intermediate-drawer'
  | 'transfer-to-service-center-drawer'
  | 'operational-settings'
  | 'add-request'
  | 'request-details'
  | 'photo-gallery'
  | 'custom-tooltip'
  | 'transaction-confirmation'
  | 'progress-backdrop'
  | 'operator-to-guarantee-drawer'

const modals: ModalsType[] = observable([])
export const isModalOpen: Partial<Record<ModalsType, boolean>> = observable({})
export const modalData: Partial<Record<ModalsType, any>> = observable({})
export const toggleModalFn: Partial<Record<ModalsType, (data?: any) => void>> =
  observable({})
export const openModalFn: Partial<Record<ModalsType, (data?: any) => void>> =
  observable({})
export const closeModalFn: Partial<Record<ModalsType, (data?: any) => void>> =
  observable({})

export function regModal(modalName: ModalsType) {
  if (modals.slice().includes(modalName)) {
    throw new Error(`Modal "${modalName}" is already registered.`)
  } else if (!modalName) {
    throw new Error(`Modal name must be provided.`)
  }
  modals.push(modalName)
  setModalData(modalName, {})
  isModalOpen[modalName] = false
  toggleModalFn[modalName] = (data?: any): void => {
    if (isModalOpen[modalName]) {
      isModalOpen[modalName] = false
      setTimeout(() => {
        modalData[modalName] = {}
      }, 100)
    } else {
      if (data) {
        setModalData(modalName, data)
      }
      isModalOpen[modalName] = true
    }
  }
  openModalFn[modalName] = (data) => {
    if (data) {
      setModalData(modalName, data)
    }
    isModalOpen[modalName] = true
  }
  closeModalFn[modalName] = () => {
    isModalOpen[modalName] = false
    if (modalData[modalName]) {
      setTimeout(() => {
        modalData[modalName] = {}
      }, 100)
    }
  }
}

export function setModalData(modalName: ModalsType, data: any) {
  if (!modals.slice().includes(modalName)) {
    regModal(modalName)
  }
  modalData[modalName] = data
}

export function disposeModal(modalName: ModalsType) {
  modals.splice(modals.indexOf(modalName), 1)
  delete isModalOpen[modalName]
  delete toggleModalFn[modalName]
  delete openModalFn[modalName]
  delete closeModalFn[modalName]
}
